module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAOCAYAAADNGCeJAAAABHNCSVQICAgIfAhkiAAAAJRJREFUOE+tk8ENwkAMBGfLIU0ARaQF+EEBfKEA+IUW0sQFaiCUsygoQjwOpEvsp22N7F1bZMJ2Apa52p9cUiCsy8IKJ/q0x8Ns74AtUE2YqgcaSRfZ3o9iHyQ9S2G2F8AJuA2wB1BL6ie4mCStbQ8btXNhnaTVNyxizSNwf7s56raZYcBV0jn+NEod/NUf+U6xv/kCVsFNfxf+xlkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/examinatSystem/fileIcon.png
// module id = N3JW
// module chunks = 3